// BASE API AND ENDPOINTS
export const BASE_URL = import.meta.env.VITE_APP_BASEURL;
export const VALIDATE_TELEGRAM_DATA_BASE_PATH =
  import.meta.env.VITE_APP_VALIDATE_TELEGRAM_DATA ?? "/validateTelegramData";
export const GET_SUBSCRIPTION_PATH =
  import.meta.env.VITE_APP_GET_SUBSCRIPTION ?? "/subscription";
export const LOGOUT_PATH = import.meta.env.VITE_APP_POST_LOGOUT ?? "/logout";
export const PRICE_PATH = import.meta.env.VITE_APP_GET_PRICE ?? "/price";
export const PAYMENT_METHODS_PATH =
  import.meta.env.VITE_APP_GET_PAYMENT_METHODS ?? "/paymentMethods";
export const CREATE_BILL_PATH = import.meta.env.VITE_APP_CREATE_BILL ?? "/bill";
export const GET_BILLS_PATH = import.meta.env.VITE_APP_GET_BILLS ?? "/bills";
export const CHECK_BILL_STATUS_PATH =
  import.meta.env.VITE_APP_CHECK_BILL_STATUS ?? "/bill";
export const GET_SERVERS_PATH =
  import.meta.env.VITE_APP_GET_SERVERS ?? "/servers";
export const GET_USER_INFO = import.meta.env.VITE_APP_GET_USER_INFO ?? "/me";
export const SET_EMAIL_PATH = import.meta.env.VITE_APP_SET_EMAIL ?? "/setEmail";
export const DISABLE_AUTOPAYMENTS_PATH =
  import.meta.env.VITE_DISABLE_AUTOPAYMENTS ?? "/disable_autopayments";
export const GET_CONNECT_PATH = "/connect";
export const LOGIN_PATH = import.meta.env.VITE_APP_LOGIN ?? "/login";
export const SET_CREDENTIALS_PATH =
  import.meta.env.VITE_APP_SET_CREDENTIALS ?? "/setCredentials";
export const CHANGE_PASSWORD_PATH =
  import.meta.env.VITE_APP_CHANGE_PASSWORD ?? "/changePassword";
export const GENERATE_TEST_TOKEN_PATH =
  import.meta.env.VITE_APP_GENERATE_TEST_TOKEN ?? "/generateTestToken";
export const RESTORE_PASSWORD_PATH =
  import.meta.env.VITE_APP_RESTORE_PASSWORD ?? "/restorePassword";
export const VERIFY_RESTORE_CODE_PATH =
  import.meta.env.VITE_APP_VERIFY_RESTORE_CODE ?? "/verifyRestoreCode";
export const SET_RESTORED_PASSWORD_PATH =
  import.meta.env.VITE_APP_SET_RESTORED_PASSWORD ?? "/setRestoredPassword";
export const PRIVACY_POLICY_PATH =
  import.meta.env.VITE_APP_GET_PRIVACY_POLICY ?? "/privacy-policy";

// AUTH
export const VALIDATE_TELEGRAM_DATA_URL = `${BASE_URL}${VALIDATE_TELEGRAM_DATA_BASE_PATH}`;
export const LOGIN_URL = `${BASE_URL}${LOGIN_PATH}`;
export const SET_CREDENTIALS_URL = `${BASE_URL}${SET_CREDENTIALS_PATH}`;
export const CHANGE_PASSWORD_URL = `${BASE_URL}${CHANGE_PASSWORD_PATH}`;
export const GENERATE_TEST_TOKEN_URL = `${BASE_URL}${GENERATE_TEST_TOKEN_PATH}`;
export const RESTORE_PASSWORD_URL = `${BASE_URL}${RESTORE_PASSWORD_PATH}`;
export const VERIFY_RESTORE_CODE_URL = `${BASE_URL}${VERIFY_RESTORE_CODE_PATH}`;
export const SET_RESTORED_PASSWORD_URL = `${BASE_URL}${SET_RESTORED_PASSWORD_PATH}`;
export const PRIVACY_POLICY_URL = `${BASE_URL}${PRIVACY_POLICY_PATH}`;

// SUBSCRIPTION
export const GET_SUBSCRIPTION_URL = `${BASE_URL}${GET_SUBSCRIPTION_PATH}`;

// LOGOUT
export const LOGOUT_URL = `${BASE_URL}${LOGOUT_PATH}`;

// PRICE
export const PRICE_URL = `${BASE_URL}${PRICE_PATH}`;

// PAYMENT METHODS
export const PAYMENT_METHODS_URL = `${BASE_URL}${PAYMENT_METHODS_PATH}`;

// CREATE BILL
export const CREATE_BILL_URL = `${BASE_URL}${CREATE_BILL_PATH}`;

// GET BILLS HISTORY
export const GET_BILLS_URL = `${BASE_URL}${GET_BILLS_PATH}`;

// CHECK BILL STATUS
export const CHECK_BILL_STATUS_URL = `${BASE_URL}${CHECK_BILL_STATUS_PATH}`;

// GET SERVERS
export const GET_SERVERS_URL = `${BASE_URL}${GET_SERVERS_PATH}`;

// USER INFO
export const GET_USER_INFO_URL = `${BASE_URL}${GET_USER_INFO}`;

// SET USER EMAIL
export const SET_EMAIL_URL = `${BASE_URL}${SET_EMAIL_PATH}`;

// PROFILE
export const ME_URL = GET_USER_INFO_URL;

// DISABLE AUTOPAYMENTS
export const DISABLE_AUTOPAYMENTS_URL = `${BASE_URL}${DISABLE_AUTOPAYMENTS_PATH}`;

// GET CONNECT
export const GET_CONNECT_URL = `${BASE_URL}${GET_CONNECT_PATH}`;
